export enum MessageTypes {
    Loaded = 'GUTTER_LOADED',
    Resize = 'GUTTER_RESIZE',
    UpdateOrder = 'GUTTER_UPDATE_ORDER',
    Submit = 'GUTTER_SUBMIT_KREATOR',
	Filter = 'GUTTER_FILTER'
}

interface MessageData {
	type: MessageTypes,
	content?: any
}

let parentOrigin: string | null = null;

export const setParentOrigin = (origin: string) => {
	parentOrigin = origin;
}

export const getParentOrigin = () => {
	return parentOrigin;
}

const sendParent = (msg: MessageData) => {
	window.parent.postMessage(msg, parentOrigin);
}

export const sendParentLoaded = () => {
	const msg: MessageData = {
		type: MessageTypes.Loaded
	}

	sendParent(msg);
}

export const sendParentResize = (height: string) => {
	const msg: MessageData = {
		type: MessageTypes.Resize,
		content: height
	}

	sendParent(msg);
}

export const sendParentSubmitKreator = (order: any) => {
	const msg: MessageData = {
		type: MessageTypes.Submit,
		content: order
	}

	sendParent(msg);
}

export const sendParentFilter = (order: any) => {
	const msg: MessageData = {
		type: MessageTypes.Filter,
		content: order
	}

	sendParent(msg);
}

export const handleParentMessage = (event: MessageEvent) => {
	event.preventDefault();
	event.stopPropagation();

	const { origin, data } = event;

	if (origin !== parentOrigin) return;

	const { type, content } = data;

	switch (type) {
		case MessageTypes.UpdateOrder:
			(window as any).updateOrder(content);
			break;
		default:
			break;
	}
}